// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { xBaseTheme } from "@flip/XDL/types";
import color from "@flip/XDL/Utilities/color";
import CheckboxPresentationPropsDefault from "@insite/mobius/Checkbox/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export const CheckboxInputSelect = `span[role="checkbox"]`;

export const CheckboxCheckedSelector = `
    &[aria-checked="true"]:not([aria-disabled="true"]),
    &[aria-checked="mixed"]:not([aria-disabled="true"])
`;

export const CheckboxDefaultSelector = `&[aria-checked="false"]:not([aria-disabled="true"])`;
export const CheckboxDsiabledSelector = `&[aria-disabled="true"]`;

// XNG-Changes: FLIP-824
const defaultStateStyles = css`
    & ${CheckboxInputSelect} {
        height: 13px;
        min-width: 13px;
        width: 13px;
        border-color: ${color("common.ui4")};
        border-radius: 1px;
        background: ${color("common.ui2")};
        vertical-align: middle;
        &:focus {
            box-shadow: none;
        }
        & + label {
            margin-left: 8px;
        }
    }
`;

const checkedStyle = css`
    & ${CheckboxInputSelect} {
        ${CheckboxCheckedSelector} {
            background: ${color("common.ui12")};
            border-color: ${color("common.ui12")};
            color: ${color("common.ui1")};
        }
    }
`;
const hoverStyle = css`
    &:hover {
        ${CheckboxInputSelect} {
            ${CheckboxCheckedSelector} {
                background: ${color("common.ui13")};
                border-color: ${color("common.ui13")};
            }
            ${CheckboxDefaultSelector} {
                border-color: ${color("common.ui13")};
            }
        }
    }
`;

const disabledStyle = css`
    ${CheckboxInputSelect} {
        ${CheckboxDsiabledSelector} {
            background: ${color("common.ui2")};
            border: 1px solid ${color("common.border")};
        }
    }
`;

export default {
    // XNG-Changes: FLIP-824
    defaultProps: {
        ...CheckboxPresentationPropsDefault,
        mergeCss: true,
        typographyProps: {
            mergeCss: true,
            size: 12,
            weight: fontConfig.weight.regular,
            color: "text.main",
            css: css`
                letter-spacing: 0;
                line-height: 12px;
                user-select: none;
            `,
        },
        iconProps: {
            size: 13,
        },
        css: css`
            &:not(:disabled) {
                cursor: pointer;
            }
            ${defaultStateStyles}
            ${hoverStyle}
            ${checkedStyle}
            ${disabledStyle}
        `,
    },
    groupDefaultProps: {
        labelProps: {
            variant: "h6",
        },
        errorProps: {
            css: css`
                &:empty {
                    display: none;
                }
            `,
        },
        css: css`
            & > ${TypographyStyle as any} {
                font-size: 12px;
                font-weight: bold;
                margin-bottom: 20px;
                &:empty {
                    display: none;
                }
            }
        `,
    },
} as xBaseTheme["checkbox"];
